import { Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatStepper, MatStepperIntl } from '@angular/material/stepper';
import { CdkStep, STEPPER_GLOBAL_OPTIONS, StepperSelectionEvent } from '@angular/cdk/stepper';


@Component({
    selector: 'app-vertical-stepper',
    templateUrl: './vertical-stepper.component.html',
    styleUrls: ['./vertical-stepper.component.scss'],
    providers: [{
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { displayDefaultIndicatorType: false, showError: true }
        }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VerticalStepperComponent implements OnInit, OnChanges{
  
  isLinear = false;
  firstFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;

  @Input() stepperDetails;

  currentStep;

  constructor(private stepper: MatStepperIntl, private _formBuilder: UntypedFormBuilder) {
    // super();
  }

  ngOnInit() {
    // this.firstFormGroup = this._formBuilder.group({
    //   firstCtrl: ['', Validators.required]
    // });
    // this.secondFormGroup = this._formBuilder.group({
    //   secondCtrl: ['', Validators.required]
    // });
    this.currentStep = this.stepperDetails.active;
  }

  step1Completion = false;
  step2Completion = false;
  step3Completion = false;

  isStep1Failed = false;
  isStep2Failed = false;
  isStep3Failed = false;
  ngOnChanges(changes: SimpleChanges) {
    if (changes['stepperDetails']) {
      this.stepperDetails.childStatus.forEach(element => {
        if(element.name === 'DATA_VALIDATION'){          
          if(element.envStatus === 'SUCCESS')
            this.step1Completion = true;
          else if(element.envStatus === 'FAILED')  
            this.isStep1Failed = true;
        }
        else if(element.name === 'DOMAIN_CREATION'){ 
          // if(this.isStep1Failed){

          // }
          if(element.envStatus === 'SUCCESS')
            this.step2Completion = true;
          else if(element.envStatus === 'FAILED')  
            this.isStep2Failed = true;
        }
        else if(element.name === 'MASTER_DATA_UPLOAD'){          
          if(element.envStatus === 'SUCCESS')
            this.step3Completion = true;
          else if(element.envStatus === 'FAILED')  
            this.isStep3Failed = true;
        }
      });

      console.log(this.stepper)
      this.stepper.changes.subscribe(d=>{
        console.log(d)
      })
      // this.stepChanged()
    }    
  }

  stepChanged(event: StepperSelectionEvent, stepper) {    
    console.log(stepper);    

    // if(event.selectedIndex === 0){
    //   if(this.isStep1Failed)
    //     event.selectedStep.hasError = true
    // }      
    // else if(event.selectedIndex === 1){
    //   if(this.isStep2Failed)
    //     event.selectedStep.hasError = true;    
    // }      
    // else if(event.selectedIndex === 2){
    //   if(this.isStep3Failed)
    //     event.selectedStep.hasError = true;    
    // }             
  }

}
